// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-create-form .custom-control-label {
  margin-top: 6px;
}
.user-create-form .custom-control-label::before, .user-create-form .custom-control-label::after {
  top: 0.15rem;
}`, "",{"version":3,"sources":["webpack://./src/neetjee_guru/components/settings/user_creations/_usercreation.scss"],"names":[],"mappings":"AACI;EACI,eAAA;AAAR;AAEQ;EAEI,YAAA;AADZ","sourcesContent":[".user-create-form {\n    .custom-control-label {\n        margin-top: 6px;\n\n        &::before,\n        &::after {\n            top: 0.15rem;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
